export default __webpack_public_path__ + "static/media/contact.1e170c0c.jpeg";